export const mauve = {
  1: { value: { base: '{colors.mauve.light.1}', _dark: '{colors.mauve.dark.1}' } },
  2: { value: { base: '{colors.mauve.light.2}', _dark: '{colors.mauve.dark.2}' } },
  3: { value: { base: '{colors.mauve.light.3}', _dark: '{colors.mauve.dark.3}' } },
  4: { value: { base: '{colors.mauve.light.4}', _dark: '{colors.mauve.dark.4}' } },
  5: { value: { base: '{colors.mauve.light.5}', _dark: '{colors.mauve.dark.5}' } },
  6: { value: { base: '{colors.mauve.light.6}', _dark: '{colors.mauve.dark.6}' } },
  7: { value: { base: '{colors.mauve.light.7}', _dark: '{colors.mauve.dark.7}' } },
  8: { value: { base: '{colors.mauve.light.8}', _dark: '{colors.mauve.dark.8}' } },
  9: { value: { base: '{colors.mauve.light.9}', _dark: '{colors.mauve.dark.9}' } },
  10: { value: { base: '{colors.mauve.light.10}', _dark: '{colors.mauve.dark.10}' } },
  11: { value: { base: '{colors.mauve.light.11}', _dark: '{colors.mauve.dark.11}' } },
  12: { value: { base: '{colors.mauve.light.12}', _dark: '{colors.mauve.dark.12}' } },
  a1: { value: { base: '{colors.mauve.light.a1}', _dark: '{colors.mauve.dark.a1}' } },
  a2: { value: { base: '{colors.mauve.light.a2}', _dark: '{colors.mauve.dark.a2}' } },
  a3: { value: { base: '{colors.mauve.light.a3}', _dark: '{colors.mauve.dark.a3}' } },
  a4: { value: { base: '{colors.mauve.light.a4}', _dark: '{colors.mauve.dark.a4}' } },
  a5: { value: { base: '{colors.mauve.light.a5}', _dark: '{colors.mauve.dark.a5}' } },
  a6: { value: { base: '{colors.mauve.light.a6}', _dark: '{colors.mauve.dark.a6}' } },
  a7: { value: { base: '{colors.mauve.light.a7}', _dark: '{colors.mauve.dark.a7}' } },
  a8: { value: { base: '{colors.mauve.light.a8}', _dark: '{colors.mauve.dark.a8}' } },
  a9: { value: { base: '{colors.mauve.light.a9}', _dark: '{colors.mauve.dark.a9}' } },
  a10: { value: { base: '{colors.mauve.light.a10}', _dark: '{colors.mauve.dark.a10}' } },
  a11: { value: { base: '{colors.mauve.light.a11}', _dark: '{colors.mauve.dark.a11}' } },
  a12: { value: { base: '{colors.mauve.light.a12}', _dark: '{colors.mauve.dark.a12}' } },
}
